<template>
  <div class="row">
    <div class="col-4">
      <h1 class="heading-l--black title-500 pb-4">
        {{ $t('user-dashboard.heading') }}
      </h1>

      <tws-action-button
        @click="redirectToPasswordChange">
        <TeliaCoreIcon
          class="search-icon"
          name="secured_thin"
          size="3rem" />
        <span>{{ $t('user-dashboard.change-password') }}</span>
      </tws-action-button>
    </div>
  </div>
</template>

<script>
import { TwsActionButton } from 'tws-vue-components'

export default {
  components: {
    TwsActionButton
  },
  methods: {
    redirectToPasswordChange () {
      const adapterId = process.env.VUE_APP_OAUTH_ADAPTER_ID
      const baseUrl = process.env.VUE_APP_OAUTH_AUTHORITY
      const changePasswordPath = `/ext/pwdchange/Identify?AdapterId=${adapterId}`
      const fullUrl = `https://${baseUrl}${changePasswordPath}`
      window.location.href = fullUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.heading-l {
  margin-bottom: 25px;
}

.action-link {
  width: 295px;
}
</style>
